import React from 'react'
import {
  ArrayInput,
  FormDataConsumer,
  required,
  SimpleFormIterator,
} from 'react-admin'
import { ProfessionalFigure } from 'services/api/entities/catalog/professional/types/internal/professional-models'
import {
  ProfessionalServiceConfig,
  ServicesConfig,
} from 'services/api/entities/servicesconfig'
import { useKGetList } from 'services/hooks/useKGetList'
import { FormDataConsumerProps } from 'types/common'
import BriefQuestionArrayInput from 'ui-shared/FormComponents/BriefQuestionArrayInput'
import Kdivider from 'ui-shared/LayoutComponents/Kdivider'
import KFormTab from 'ui-shared/WrappedInputs/KFormTab'
import KNumberInput from 'ui-shared/WrappedInputs/KNumberInput'

// FIXME: find out if we can change this any typing
const ProfessionalsCfgTab: React.FC<any> = (props) => {
  // we need to remove these entries from the props to avoid triggering errors in the nested components
  const { undoable, saving, save, ...rest } = props
  const productChoices = useKGetList<ProfessionalFigure>('professionals')
  return (
    <KFormTab {...rest} label="form.tabs.professionals">
      <Kdivider title="Service Time Limit" />
      <KNumberInput
        source="professionalService.advanceReservationMin"
        label="form.fields.advanceReservationMin"
        validate={required()}
      />
      <Kdivider title="Brief Questions" />
      <ArrayInput
        source="professionalService.services"
        label="Professional Services"
      >
        <SimpleFormIterator disableAdd disableRemove>
          <FormDataConsumer>
            {({
              scopedFormData,
              getSource,
            }: FormDataConsumerProps<
              ServicesConfig,
              ProfessionalServiceConfig
            >) => {
              if (!scopedFormData) return null
              return (
                <>
                  <h3>{scopedFormData.section.name}</h3>
                  <BriefQuestionArrayInput
                    source={getSource!('brief')}
                    productChoices={productChoices.filter(
                      (product) =>
                        product.sectionName === scopedFormData.section.name
                    )}
                  />
                </>
              )
            }}
          </FormDataConsumer>
        </SimpleFormIterator>
      </ArrayInput>
    </KFormTab>
  )
}

export default ProfessionalsCfgTab
